import * as React from "react";
import { Helmet } from "react-helmet";

// Components
import PageWrapper from "../../Components/Layouts/PageWrapper";
import CardLayout from "../../Components/Layouts/CardLayout";

import LoginForm from "./LoginForm";

export default class Login extends React.Component {
  render() {
    return (
      <PageWrapper>
        <CardLayout>
          <LoginForm />
        </CardLayout>
        <Helmet title="Sign In" />
      </PageWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Login/index.tsx